export default __webpack_public_path__ + "static/media/fa-solid-900.32267f3b.ttf";